"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetsPerTask = getAssetsPerTask;
const taskStore_1 = require("../../../taskStore");
async function getAssetsPerTask(isDev, useRoarHfBucket) {
    try {
        const url = useRoarHfBucket
            ? `https://storage.googleapis.com/roar-levante-tasks/audio/assets-per-task.json`
            : `https://storage.googleapis.com/levante-assets-${isDev ? 'dev' : 'prod'}/audio/assets-per-task.json`;
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }
        const assetsPerTask = await response.json();
        (0, taskStore_1.taskStore)('assetsPerTask', assetsPerTask);
    }
    catch (error) {
        console.error('Error fetching JSON:', error);
    }
}
